export const CHOOSE_QUESTIONNAIRE_LANGUAGE = 'CHOOSE_QUESTIONNAIRE_LANGUAGE';
export const REMOVE_QUESTIONNAIRE_LANGUAGE = 'REMOVE_QUESTIONNAIRE_LANGUAGE';
export const UPDATE_QUESTIONNAIRE_LANGUAGE_FROM_LOCALSTORAGE = 'UPDATE_QUESTIONNAIRE_LANGUAGE_FROM_LOCALSTORAGE';